export class ListQueryExecutionsRequestSortsInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "ListQueryExecutionsRequestSortsInnerFieldEnum",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "ListQueryExecutionsRequestSortsInnerOrderEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListQueryExecutionsRequestSortsInner.attributeTypeMap;
    }
    constructor() {
    }
}
export var ListQueryExecutionsRequestSortsInnerFieldEnum;
(function (ListQueryExecutionsRequestSortsInnerFieldEnum) {
    ListQueryExecutionsRequestSortsInnerFieldEnum["CreatedAt"] = "CREATED_AT";
    ListQueryExecutionsRequestSortsInnerFieldEnum["FinishedAt"] = "FINISHED_AT";
})(ListQueryExecutionsRequestSortsInnerFieldEnum || (ListQueryExecutionsRequestSortsInnerFieldEnum = {}));
export var ListQueryExecutionsRequestSortsInnerOrderEnum;
(function (ListQueryExecutionsRequestSortsInnerOrderEnum) {
    ListQueryExecutionsRequestSortsInnerOrderEnum["Asc"] = "ASC";
    ListQueryExecutionsRequestSortsInnerOrderEnum["Desc"] = "DESC";
})(ListQueryExecutionsRequestSortsInnerOrderEnum || (ListQueryExecutionsRequestSortsInnerOrderEnum = {}));
